var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.235352 5.1123C0.235352 7.47559 2.1582 9.39844 4.52148 9.39844C5.45605 9.39844 6.31006 9.09766 7.01367 8.59277L9.65625 11.2407C9.77979 11.3643 9.94092 11.4233 10.1128 11.4233C10.478 11.4233 10.7305 11.1494 10.7305 10.7896C10.7305 10.6177 10.666 10.4619 10.5532 10.3491L7.92676 7.70654C8.47998 6.98682 8.80762 6.08984 8.80762 5.1123C8.80762 2.74902 6.88477 0.826172 4.52148 0.826172C2.1582 0.826172 0.235352 2.74902 0.235352 5.1123ZM1.15381 5.1123C1.15381 3.25391 2.66309 1.74463 4.52148 1.74463C6.37988 1.74463 7.88916 3.25391 7.88916 5.1123C7.88916 6.9707 6.37988 8.47998 4.52148 8.47998C2.66309 8.47998 1.15381 6.9707 1.15381 5.1123Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b18af366a43db889fa309d33078d6cd8.svg";
export { ForwardRef as ReactComponent };